import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { Users, Businesses, BusinessOptions, WaitingList, Notifications, Suggestions } from './modules';

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    key: 'pmp_admin_web_application',
    // TODO: Setup reducer OR modules, to only persist what's needed. Default (as is now) is to persist everything
    reducer: state => ({
        token: state.token,
        signedIn: state.signedIn,
        role: state.role,
        business: state.business,
        lang: state.lang,
    }),
});

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        token: null,
        signedIn: false,
        snackbarMessage: '',
        snackbarColor: '',
        role: null,
        business: null,
        loading: false,
        lang: 'en',
    },
    mutations: {
        clearToken: state => {
            state.signedIn = false;
            state.token = null;
        },
        setToken: (state, { loginResponse }) => {
            state.token = loginResponse.access_token;
            state.signedIn = true;
        },
        setRole: (state, { role }) => {
            state.role = role;
        },
        setBusiness: (state, { business }) => {
            state.business = business;
        },
        setSnackbarStatus: (state, status) => {
            state.snackbarMessage = status.message;
            state.snackbarColor = status.color;
        },
        setLoading: (state, isActive) => {
            state.loading = isActive;
        },
        setLang: (state, { lang }) => {
            state.lang = lang;
        },
    },
    getters: {
        isLoading: state => state.loading === true,
        isAdmin: state => state.role === 'admin',
    },
    actions: {},
    modules: {
        Users,
        Businesses,
        BusinessOptions,
        WaitingList,
        Notifications,
        Suggestions,
    },
    plugins: [vuexLocal.plugin],
});

export default store;
